export default () => {
  const form = document.querySelectorAll('.SearchHero-searchButton[type="submit"]');

  if (form.length > 0) {
    for (let i = 0; i < form.length; i++) {
      form[i].addEventListener('click', (event) => {
        event.preventDefault();
        let inputOneValue = '';
        let inputTwoValue = '';

        const predictiveInput = $('.predective-input');

        inputOneValue = predictiveInput.get(0) ? predictiveInput.get(0).value : '';
        inputTwoValue = predictiveInput.get(1) ? predictiveInput.get(1).value : '';

        if (inputOneValue === '' && inputTwoValue === '') {
          alert('Please, enter a place to search');
          return;
        }

        let id = '';
        var productName = '';

        jQuery('input[name="search-rental-category"]').each(function() {
          if (jQuery(this).val() !== '') {
            productName = jQuery(this).val();

            return;
          }
        });

        const form = document.querySelector('.SearchHero-form');
        id = jQuery(`.TypeAhead-resultItem.TypeAhead-resultItem--selectable:contains('${productName}')`);
        id = id.length === 0 ? '0' : id.data('uid');

        var place = window.autocomplete.getPlace() === undefined
          ? window.autocomplete2.getPlace()
          : window.autocomplete.getPlace();

        if (!place.geometry) {
          alert('Returned place can\'t be found');
          return;
        }

        const idInput = document.createElement('input');
        idInput.setAttribute('type', 'hidden');
        idInput.setAttribute('name', 'search-rental-id');
        idInput.setAttribute('value', id);

        const latInput = document.createElement('input');
        latInput.setAttribute('type', 'hidden');
        latInput.setAttribute('name', 'search-rental-lat');
        latInput.setAttribute('value', place.geometry.location.lat().toString());

        const lngInput = document.createElement('input');
        lngInput.setAttribute('type', 'hidden');
        lngInput.setAttribute('name', 'search-rental-lng');
        lngInput.setAttribute('value', place.geometry.location.lng().toString());

        form.appendChild(idInput);
        form.appendChild(latInput);
        form.appendChild(lngInput);
        form.submit();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/util/searchFormHandler.js